import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05288ce2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media children" }
const _hoisted_2 = { class: "articles articles-page" }
const _hoisted_3 = { class: "articles-contents" }
const _hoisted_4 = { class: "plist" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "date"
}
const _hoisted_7 = { class: "title" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "not-found c-secondary"
}

import userApi from '@/api/userApi';
import { isMobile } from '@/common/download';
import { setting } from '@/config';
import channel, { State } from '@/store/channels/channel';
import home from '@/store/channels/home';
import i18, { State as I18State } from '@/store/i18';
import user, { State as UserState } from '@/store/user';
import { computed, onMounted, reactive, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import * as filters from '@/views/filters';
import ChannelInfo from './ChannelInfo.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const route = useRoute()
const channelId = computed(() => parseInt(route.params.id as string))
const store = useStore()
const leftData = computed(() => store.state[home.name].left)
const data = computed<State>(() => store.state[channel.name])
const userData = computed<UserState>(() => store.state[user.name]);
const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

const temp = reactive({
    loading: false,
    text: '',
    favorite: false,
})

onMounted(() => {
    if (userData.value.info) {
        checkMyFavorite()
    }
    if (isMobile() && setting.first) {
        window.location.href = 'fuyintv://ttlx/bible/' + channelId.value
    }
})

watch(channelId, () => {
    if (userData.value.info) {
        checkMyFavorite()
    }
})

async function checkMyFavorite() {
    if (leftData.value.channels.length > 0) {
        temp.favorite = leftData.value.channels.some((item: any) => item.id == channelId.value)
    }
    temp.favorite = await userApi.isMyChannel(channelId.value)
}

function onSelected(id: number) {
    router.push(`/channels/articles/${id}.html`)
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ChannelInfo),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).articles, (current) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["p1", { big: current.list.length == 1 }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(current.list, (item, i) => {
                  return (_openBlock(), _createElementBlock("a", {
                    class: "item",
                    onClick: ($event: any) => {onSelected(item.itemid);}
                  }, [
                    (i == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(filters).date(item.addtime)), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(item.title), 1),
                    _createElementVNode("div", {
                      class: "poster",
                      style: _normalizeStyle(_unref(filters).bg(item.thumb))
                    }, null, 4),
                    _hoisted_8
                  ], 8, _hoisted_5))
                }), 256))
              ], 2))
            }), 256))
          ])
        ]),
        (_unref(data).articles.length == 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(lang).movieText.empty), 1))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})